import {videoPlayerSettings} from '../../../bps/components/videoPlayer/videoPlayerSettings';

videoPlayerSettings.color = '179287';

export {videoPlayerSettings}
